import classnames from 'classnames'
import React from 'react'
import { Accordion, Button, Heading, Dropdown } from '@scentregroup/ui'
import { OnSearchFunc } from '@scentregroup/shared/hub-components/searchable-faceted-filter'
import { IFacet, IFacetSelections } from '../../types/facets'
import { ICategory } from '../../types/marketplace-categories'
import { isFacetOptionSelected } from '../../lib/facets'
import trackMkpEvents, { labels } from '../../lib/market-place-track-event'
import { onSelectById } from './faceted-filters-utils'
import style from './index.module.scss'
import { FilterType } from '.'
import FacetedFilter from './faceted-filter'
import ProductTypeFilter from './product-type-filter'
import { ICategoryList } from './category-list'

interface ILargeFacetedFiltersProps {
  category?: ICategory
  categoryListElement: React.FunctionComponentElement<ICategoryList> | undefined
  facets: IFacet[]
  facetSelections: IFacetSelections
  productTypeSelections: string[]
  searchParams?: string
  isLinked?: boolean
  onChangeFacetSelections(facetSelections: IFacetSelections): void
  onChangeProductTypeSelections(productTypeSelections: string[]): void
  onClearAll(): void
  onFacetOptionSearch?: OnSearchFunc
}

export const LargeFacetedFilters: React.FunctionComponent<
  React.PropsWithChildren<ILargeFacetedFiltersProps>
> = ({
  category,
  categoryListElement,
  facets,
  facetSelections,
  productTypeSelections,
  isLinked = false,
  onChangeFacetSelections,
  onChangeProductTypeSelections,
  onClearAll,
  onFacetOptionSearch,
}) => {
  return (
    <>
      {categoryListElement && category && category.children.length > 0 ? (
        <div className={style.categoryWrapper}>
          <div className={classnames(style.header, style.categoryHeader)}>
            <Heading type="small" className={style.headerText}>
              Category
            </Heading>
          </div>
          {categoryListElement}
        </div>
      ) : (
        category?.productTypes &&
        category.productTypes.length > 0 && (
          <>
            <div className={classnames(style.header, style.productTypeHeader)}>
              <Heading type="small" className={style.headerText}>
                Type
              </Heading>
            </div>
            <div className={style.productTypeFilter}>
              <ProductTypeFilter
                productTypes={category.productTypes}
                productTypeSelections={productTypeSelections}
                onChangeProductTypeSelections={onChangeProductTypeSelections}
              />
            </div>
          </>
        )
      )}
      <div className={style.header}>
        <Heading type="small" className={style.headerText}>
          Filter
        </Heading>
        <Button
          className={style.actionClear}
          type="tertiary"
          onClick={onClearAll}
        >
          Clear all
        </Button>
      </div>
      {facets.map((facet: IFacet) => {
        const { id, title, options, type } = facet
        return (
          <Accordion
            key={`${category?.path.map(pc => pc.code).join()}-${id}`}
            label={title}
            id={id}
            type={'small'}
            classNames={{
              wrapper: style.facetedFilterWrapper,
              content: style.facetedFilterContent,
            }}
            onClick={() =>
              trackMkpEvents.expanded(labels.createFiltersFacet(title))
            }
          >
            {type && type === FilterType.SINGLE_CHOICE ? (
              <Dropdown
                id={id}
                size="SMALL"
                options={options.map(option => ({
                  value: option.id,
                  label: option.label,
                }))}
                value={
                  options.find(option =>
                    isFacetOptionSelected(facetSelections, id, option.id)
                  )?.id ?? ''
                }
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                  const selection = event.target.value && [event.target.value]
                  onSelectById(
                    id,
                    selection || [],
                    facets,
                    facetSelections,
                    onChangeFacetSelections
                  )
                }}
              />
            ) : (
              <FacetedFilter
                facet={facet}
                allFacets={facets}
                facetSelections={facetSelections}
                isLinked={isLinked}
                onChangeFacetSelections={onChangeFacetSelections}
                onSearch={onFacetOptionSearch}
              />
            )}
          </Accordion>
        )
      })}
    </>
  )
}
